import { render, staticRenderFns } from "./TemplateItemsModal.vue?vue&type=template&id=7a6ddafa&scoped=true"
import script from "./TemplateItemsModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemsModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemsModal.vue?vue&type=style&index=0&id=7a6ddafa&prod&scoped=true&lang=css"
import style1 from "./TemplateItemsModal.vue?vue&type=style&index=1&id=7a6ddafa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ddafa",
  null
  
)

export default component.exports